import Vue from "vue";
import { FlashMessageService } from "zoox-infra";
import { mapActions, mapState } from "vuex";
import { ReservationService, CompanyService } from "smck-service";
import GuestControlService from "@/service/guest-control-service";
import moment from "moment";
import StrategyManager from "@/strategies/manager";

const SessionMixin = {
  data() {
    return {
      isiOS:
        (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window["MSStream"]) ||
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      isIE:
        navigator.userAgent.indexOf("MSIE") > -1 ||
        navigator.appVersion.indexOf("Trident/") > -1,
      isMobile: window.innerWidth <= 1024,
      reservationService: new ReservationService(Vue),
      companyService: new CompanyService(Vue),
      guestControlService: new GuestControlService(),
      companyId: ""
    };
  },
  computed: Object.assign(
    mapState([
      "reservations",
      "currentGuest",
      "currentReservation",
      "isRec",
      "guestDocumentData",
      "lastDocumentSearch",
      "currentPersonId",
      "currentPhoto",
      "mediaSupported",
      "debugConfig",
      "currentMobileStep",
      "payStep",
      "authenticatedPersonEmail"
    ])
  ),
  mounted() {
    this.$nextTick(() => {
      const self = this;
      window.addEventListener("resize", () => {
        self.isMobile = window.innerWidth <= 1024;
      });
    });
  },
  methods: Object.assign(
    {
      $redirectSearch: function(tabIndex) {
        if (tabIndex) {
          this.$router.push({
            path: `/`,
            query: { tab: tabIndex }
          });
        } else {
          this.$router.push({
            path: `/`
          });
        }
      },
      $redirectGuestView: function(reservationId, guestId) {
        this.$router.push({
          path: `/guest/${reservationId}/${guestId}`
        });
      },
      $redirectMultReserva: function() {
        this.$router.push({
          path: `/multr`
        });
      },
      $redirectSelGuest: function(reservationId, guestId, comeFromSearch) {
        this.$router.push({
          path: `/${reservationId}/${guestId}?fromSearch=${comeFromSearch}`
        });
      },
      $redirectSuccess: function(reservationId) {
        this.$router.push({ path: `/conclusion/${reservationId}` });
      },
      $redirectResume: function(fnrhId) {
        this.$router.push({ path: `/resume/${fnrhId}` });
      },
      $autoFill: function(reservationId, personId, image, isRec) {
        return new Promise((resolve, reject) => {
          const data = {
            image: null,
            extra: []
          };
          if (image) {
            data.image = image;
          }

          this.reservationService
            .autoFill(reservationId, personId, isRec, data)
            .then(respAutoFill => {
              if (respAutoFill && respAutoFill.statusCode === 200) {
                const validatedInfo = this.reservationService.getValidatedInfo();
                respAutoFill.guests = respAutoFill.guests.map(g => {
                  if (validatedInfo.personId === g.personId) {
                    g.validated = validatedInfo.validated;
                  }

                  return g;
                });

                this.reservationService.setLocalReservation(respAutoFill);
                resolve(respAutoFill);
              } else {
                resolve(null);
              }
            })
            .catch(reject);
        });
      },
      $saveGuestDocumentData(guestId) {
        this.$setGuestDocumentData({
          guestId: guestId,
          documentData: {
            documentTypeId: this.documentSearch.documentType.value,
            documentNumber: this.documentSearch.documentNumber
          }
        });
      },
      handleReservationListResponse(task) {
        const $context = this;
        const company = this.companyService.getLocalCompany();

        if (company && company.id) {
          $context.companyId = company.id;
        }

        return task
          .then(resp => {
            if (
              resp &&
              resp.lastReservations &&
              resp.lastReservations.length > 0
            ) {
              resp.data = resp.lastReservations.filter(
                item => item.resStatus === 1
              );
              resp.meta = { total: resp.data.length };
              let hasReservationToShow = false;

              for (let i = 0; i < resp.data.length; i++) {
                const canShow = this.showCheckinButton(resp.data[i]);

                if (canShow) {
                  hasReservationToShow = true;
                  break;
                }
              }

              if (!hasReservationToShow) {
                throw "No Reservation";
              }

              if (resp.data.length > 1) {
                $context.$setReservations(resp.data);
                $context.$redirectMultReserva();
              } else if (resp.data.length === 1) {
                const reservation = resp.data[0];
                $context.$setCurrentReservation(reservation);
                $context.$handleMultipleGuests(reservation);
              } else {
                FlashMessageService.warning(
                  $context.$t("WELCOME.RESERVATION_NOT_FOUND_MESSAGE")
                );
              }
            } else {
              FlashMessageService.warning(
                $context.$t("WELCOME.RESERVATION_NOT_FOUND_MESSAGE")
              );
            }
          })
          .catch(() => {
            FlashMessageService.warning(
              $context.$t("WELCOME.RESERVATION_NOT_FOUND_MESSAGE")
            );
          });
      },
      $handleMultipleGuests: async function(
        reservation,
        comeFromSearch,
        alreadyAuthenticated
      ) {
        const guestsNotFinalized = reservation.guests.filter(item => {
          return !item.fnrhId;
        });
        if (guestsNotFinalized.length >= 1) {
          const firstGuest = guestsNotFinalized[0];
          if (!alreadyAuthenticated) {
            this.$redirectSelGuest(
              reservation.id,
              firstGuest.id,
              comeFromSearch
            );
          } else {
            // let authGuest = reservation.guests.filter(item => {
            //   return item.email === this.authenticatedPersonEmail;
            // });
            this.$startFillGuest(firstGuest.id);
          }
          // } else if (guestsNotFinalized.length === 1) {
          //
        } else {
          const guest = reservation.guests[0];

          if (this.$customization && this.$customization.enableRedirect) {
            const strategy = this.$customization.redirectTo || 0;
            const strategyManager = new StrategyManager();
            await strategyManager.setStrategy(strategy);
            await strategyManager.redirect(reservation, guest);
          } else {
            this.$redirectResume(guest.fnrhId);
          }
        }
      },
      $startFillGuest: function(guestId) {
        let x = 0;
        for (let i = 0; i < this.currentReservation.guests.length; i += 1) {
          if (this.currentReservation.guests[i].id === guestId) {
            x = i;
            break;
          }
        }

        if (this.currentPhoto) {
          this.reservationService.setGuestImage(
            this.currentReservation,
            this.currentReservation.guests[x],
            this.currentPhoto
          );
        }

        const currentGuest = this.currentReservation.guests[x];

        this.$setCurrentReservation(this.currentReservation);
        this.$setCurrentGuest(currentGuest);
        this.$redirectGuestView(this.currentReservation.id, guestId);
      },
      showCheckinButton: function(reservation) {
        const guestsNotFinalized = reservation.guests.filter(item => {
          return !item.fnrhId;
        });

        if (
          !guestsNotFinalized ||
          (guestsNotFinalized && guestsNotFinalized.length === 0)
        ) {
          return false;
        }

        if (
          moment
            .utc(reservation.checkoutDate)
            .startOf("day")
            .toDate()
            .getTime() >=
          moment
            .utc()
            .startOf("day")
            .toDate()
            .getTime()
        ) {
          return true;
        }

        return false;
      }
    },

    mapActions([
      "$resetState",
      "$setIsRec",
      "$setReservations",
      "$setCurrentGuest",
      "$setGuestDocumentData",
      "$setCurrentReservation",
      "$setDocumentSearch",
      "$setCurrentPersonId",
      "$setCurrentPhoto",
      "$setMediaNoSupport",
      "$setCurrentMobileStep",
      "$setPayStep"
    ])
  )
};

export default SessionMixin;
